import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../graphql/fragments/generated/User';
export type CertificateTemplateFragment = { id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, status: Types.CertificateTemplateStatusEnum, preview: { url?: string | null }, modelRequirement: { user?: Array<string> | null }, createdBy?: { id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null };


export type CertificateTemplateFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const CertificateTemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment CertificateTemplate on CertificateTemplateType {
  id
  name
  description
  createdAt
  updatedAt
  status
  preview {
    url
  }
  modelRequirement {
    user
  }
  createdBy {
    ...User
  }
}
    `;